<template>
  <div class="container align-content-center">
    <div class="row">
      <div class="col d-flex justify-content-center mt-4 mb-3 pt-4 small-logo-container">
          <img src="img/iqos-stories-black.svg" alt="" class="img-fluid pt-3 pb-3 logo-fixed secondary-logo">
      </div>
    </div>
    <div class="row">
      <div class="col d-flex justify-content-center mt-4 flex-column">
        <div class="instructions-headings mx-auto">
          <h3 class="text-center">Sesiunea ta a expirat.</h3>
        </div>
        <div class="instructions-text mx-auto">
          <p class="text-center">Te rugăm să te loghezi din nou.</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col mx-auto pt-4 pb-3 d-flex justify-content-center">
        <div class="start-quiz-box">
          <a href="/login" class="button button button--dark mx-auto">Intră în cont</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SessionExpired",
};
</script>

<style>
</style>